import React, { useState, useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { SaveCancel } from "../../uiControls/saveCancel";
import * as utils from "../../common/utils";
import { TableWithStickyHeaderToAddNew } from "../../uiControls/tableWithStickyHeaderToAddNew";

const userColumns = [
  {
    label: "",
    keyField: "userKey",
    dataField: "userKey",
    minWidth: 20,
    maxWidth: 20,
    fieldType: "number",
  },
  {
    label: "User (Brief)",
    keyField: "userKey",
    dataField: "userName",
    fieldType: "label",
  },
  {
    label: "Name",
    keyField: "userKey",
    dataField: "name",
    fieldType: "label",
  },
  {
    label: "Email",
    keyField: "userKey",
    dataField: "email",
    fieldType: "email",
  },
  {
    label: "Role Type",
    keyField: "userKey",
    dataField: "roleKey",
    fieldType: "dropdown",
    listSource: "roles",
  },
];

export const UserAdd = (props) => {
  const { setUpdateOpen, roles } = props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateUser } = useHttpRequests();
  const [selectedRows, setSelectedRows] = useState([]);

  const getUrl = (params) => {
    return "Users?" + params;
  };

  const cancelUserHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setUpdateOpen(false);
  };

  const validateUserDetails = () => {
    var errorSummary = "";

    if (selectedRows.some((item) => item["userName"] === "")) {
      errorSummary += "User (Brief) required. Please contact administrator. \n";
    }

    if (selectedRows.some((item) => item["name"] === "")) {
      errorSummary += "Name required. Please contact administrator. \n";
    }

    if (
      selectedRows.some(
        (item) => item["email"] !== "" && !utils.validateEmail(item["email"])
      )
    ) {
      errorSummary += "Invalid email. \n";
    }

    if (selectedRows.some((item) => item["roleKey"] === 0)) {
      errorSummary += "Select role. \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({
          type: "error",
          message: "Selected record needs review like- \n" + errorSummary,
        })
      );
    } else {
      const dataObj = selectedRows?.map((obj) => {
        return {
          userKey: obj["userKey"],
          roleKey: obj["roleKey"],
          active: true,
          email: obj["email"],
        };
      });
      const getUpdateUserResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          resObj["validationErrors"]?.length > 0
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                resObj["message"] +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "User(s) added successfully!",
          })
        );
        setTimeout(() => {
          cancelUserHandler();
        }, 2000);
      };
      updateUser(
        { url: "Users/Create/Multi", body: dataObj },
        getUpdateUserResponse
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "5px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              overflow: "auto",
            }}
          >
            <TableWithStickyHeaderToAddNew
              title="ESM Users"
              pagging={true}
              columns={userColumns}
              url={getUrl}
              sourceObj="users"
              list={{ roles: roles }}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
            <SaveCancel
              cancelCall={() => cancelUserHandler()}
              saveCall={() => validateUserDetails()}
            />
          </div>
        </div>
      </Box>
    </>
  );
};
